import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { LoginService } from './login.service';

import { UserLoginModel } from '../models/userlogin.model';

declare var moment: any;

@Injectable()
export class AccountService extends BaseService {
  responseResults: any[] = [];

  constructor(private http: HttpClient, private loginService: LoginService) {
    super();
    // super(_router);
  }

  public resetPassword(username: string) {
    var body = JSON.stringify({
      username: username, password: null, applicationGuid: environment.appToken
    });

    return this.http.put<any>(environment.commonApiUrl + 'account?username=' + this.cleanseUrlParam(username), body, this.httpOptions);
  }

  public changePassword(oldpassword: string, newpassword: string) {
    var userLogin: UserLoginModel = new UserLoginModel();
    userLogin.accountId = 0;
    userLogin.applicationGuid = environment.appToken;
    userLogin.confirmedPassword = newpassword;
    userLogin.password = oldpassword;
    userLogin.userGuid = this.getUserGuid();

    var body = JSON.stringify(userLogin);

    return this.http.put<any>(environment.commonApiUrl + 'account/' + this.cleanseUrlParam(userLogin.accountId) + '?accountKey=' + this.cleanseUrlParam(userLogin.userGuid), body, this.httpBaseOptions);
  }

  public validateSession(){
    return this.http.get<any>(environment.commonApiUrl + 'account/0/validatesession', this.httpBaseOptions).subscribe((response: any) => {
      var validSession: boolean =  response.json();
      if(!validSession) {
        this.loginService.logout();
        localStorage.removeItem('token');
      }
      return validSession as any;
    });
  }
}
